import { IconProps } from './IconProps';

export const Cart = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.08594"
        y="7.74951"
        width="13.8333"
        height="12.5"
        rx="2.78846"
        stroke="black"
        stroke-width="1.5"
      />
      <path
        d="M15.6683 7.66683C15.6683 5.2736 14.0267 3.3335 12.0016 3.3335C9.97658 3.3335 8.33496 5.2736 8.33496 7.66683"
        stroke="black"
        stroke-width="1.5"
      />
    </svg>
  );
};
